import { Action, Heading6, ModalWrapper } from "shared/components";

import { useWidgetContent } from "../Content064.context";
import styles from "./ModalCoursesList.module.scss";

export const ModalCoursesList = ({}) => {
  const { opened, availableCourses, onSelectCourse, onClose } =
    useWidgetContent();

  return opened ? (
    <ModalWrapper onCloseModal={onClose} appearance="course-list">
      <div className={styles.list}>
        {availableCourses.map(({ id, title, slug }) => (
          <Action
            key={id}
            className={styles.button}
            onClick={onSelectCourse(slug)}
          >
            <Heading6 className={styles.item} color="dark" appearance="bold">
              {title}
            </Heading6>
          </Action>
        ))}
      </div>
    </ModalWrapper>
  ) : null;
};
